import { useContext } from "react";

import PaymentProfileContext from "@/context/PaymentProfileContext";

export default function usePaymentProfile() {
  return useContext(PaymentProfileContext);
}
